<template>

  <div class="container">
    <div>
      <h3 class="main-title">Persona políticamente expuesta</h3>
      <p>
        Hemos detectado que de alguna manera estas relacionado con
        un cargo gubernamental.
      </p>
      <p>Por favor, ayudanos indicando el tipo de relación con dicho cargo.</p>
      <input
        v-model="pepType"
        type="radio"
        id="direct"
        name="pep"
        value="isDirectPep"
      />
      <label class="radio--label" for="direct">
        Yo tengo o tuve un cargo gubernamental.
      </label>
      <br>
      <input
        class="radio--mt"
        v-model="pepType"
        type="radio"
        id="indirect"
        name="pep"
        value="isIndirectPep"
      />
      <label class="radio--label" for="indirect">
        Soy familiar de alguien que tiene o tuvo un cargo gubernamental.
      </label>
    </div>
    <div class="form-container" v-if="pepType === 'isDirectPep'">
      <StepIsPep />
    </div>
    <div class="form-container" v-if="pepType === 'isIndirectPep'">
      <StepIndirectPep />
    </div>
  </div>

</template>

<script>
import StepIsPep from '@/views/userProfile/profileSteps/StepIsPep'
import StepIndirectPep from '@/views/userProfile/profileSteps/StepIndirectPep'
export default {
  name: 'PepHandler',
  components: {
    StepIsPep,
    StepIndirectPep
  },
  data () {
    return {
      pepType: ''
    }
  }
}

</script>

<style lang="scss" scoped>
 .radio--label {
   display: inline;
 }

 .radio--mt {
   margin-top: 2em;
 }

 .form-container {
   margin-top: 3em;
 }
</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/PepHandler.vue